import React, { createContext, useContext } from "react";

// Create context with default empty functions
const NavigationContext = createContext({
  registerMethods: () => {},
});

export const NavigationProvider = ({ children, value }) => {
  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};

export const useNavigation = () => useContext(NavigationContext);
